(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.legendAccountDrawer) return;
    window.legendAccountDrawer = true;
    var lastFocus = null;

    function drawer() { return document.getElementById('AccountDrawer'); }
    function overlay() { return document.querySelector('.account-drawer-overlay'); }

    function open() {
      var d = drawer();
      if (!d) return false;
      lastFocus = document.activeElement;
      if (window.premiumTheme && window.premiumTheme.closeMobileMenu) window.premiumTheme.closeMobileMenu();
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      overlay().classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { d.focus(); }, 50);
      return true;
    }

    function close() {
      var d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      overlay().classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-account-drawer-open]')) {
        if (open()) event.preventDefault();
        return;
      }
      if (event.target.closest('[data-account-drawer-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.legendMobilePanels) return;
    window.legendMobilePanels = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-mobile-panel-open]');
      if (opener) {
        var panel = document.getElementById(opener.getAttribute('data-mobile-panel-open'));
        if (panel) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        }
        return;
      }

      var back = event.target.closest('[data-mobile-panel-close]');
      if (back) {
        var openPanel = back.closest('[data-mobile-panel]');
        if (openPanel) {
          openPanel.classList.remove('is-open');
          openPanel.setAttribute('aria-hidden', 'true');
        }
      }
    });

    // Only one folding section open at a time, so the screen stays short.
    document.addEventListener(
      'toggle',
      function (event) {
        var group = event.target;
        if (!group.matches || !group.matches('[data-mobile-panel-group]') || !group.open) return;
        var panel = group.closest('[data-mobile-panel]');
        if (!panel) return;
        panel.querySelectorAll('[data-mobile-panel-group][open]').forEach(function (other) {
          if (other !== group) other.open = false;
        });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.legendCardCart) return;
    window.legendCardCart = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-card-add]');
      if (!button) return;
      event.preventDefault();

      var box = button.closest('[data-card-cart]');
      var variant = box && box.querySelector('[data-card-variant]');
      if (!variant || !variant.value) return;

      button.disabled = true;
      button.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          button.textContent = 'Added ✓';
          if (window.premiumTheme && window.premiumTheme.openCartDrawer) window.premiumTheme.openCartDrawer();
        })
        .catch(function (error) {
          button.textContent = 'Try again';
          alert(error.message);
        })
        .finally(function () {
          setTimeout(function () {
            button.disabled = false;
            button.textContent = 'Add to Cart';
          }, 1500);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
